import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { uuid } from "@ant-design/plots/es/utils";
import {
  Button,
  Col,
  DatePicker,
  InputNumber,
  Radio,
  Row,
  Select,
  Space,
  TimePicker,
  Tooltip,
} from "antd";
import { SEND_BROADCAST_TYPE } from "constants";
import { PATTERNS } from "constants/appConstant";
import dayjs from "dayjs";
import { getIn, useFormik } from "formik";
import moment from "moment/moment";
import { setIsRefresh } from "stores/slices/layout";
import { doUpdateBroadcast } from "stores/slices/message";
import {
  doGetAllMessageTemplate,
  fetchAllMessageTemplate,
} from "stores/slices/messageTemplate";
import { DAYS_OF_WEEK, OPTIONS_REPEAT } from "utils";
import * as Yup from "yup";

import AppButton from "components/button";
import FormInput from "components/forms/components/formInput";

import styles from "../broadcast/styles.module.scss";
const MessageUpdateForm = props => {
  const {
    broadcastDetail,
    onCancel,
    numberRepeat,
    setNumberRepeat,
    setSelectedRepeatType,
    selectedRepeatType,
    showErrorMessage,
    setEndDateType,
    endDateType,
    setAmountEndDate,
    setCustomEndDate,
    setCustomListWeek,
    setSelectedTimezone,
    selectedTimezone,
    setCustomDayMonth,
    setCustomDateYear,
    customDateYear,
    setTimeLater,
    setTimeRepeat,
    setRepeatType,
    setShowErrorMessage,
    timeLater,
    timeRepeat,
    customDayMonth,
    customListWeek,
    customEndDate,
    amountEndDate,
    workspaceId,
  } = props;

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const listMessageTemplate = useSelector(fetchAllMessageTemplate);

  const [optionsMessageTemplate, setOptionsMessageTemplate] = useState([]);
  const [optionsBroadcastType, setOptionBroadcastType] = useState([]);
  const [listTimezone, setListTimezone] = useState([]);
  const [loading, setLoading] = useState(false);

  const [listDays, setListDays] = useState([]);
  const [listDates, setListDates] = useState([]);
  const [disabled, setDisabled] = useState({
    isOn: true,
    isAfter: true,
  });
  const userDetail = useSelector(state => state.user.userDetail);
  const { customer } = userDetail;

  useEffect(() => {
    switch (endDateType) {
      case "NONE":
        setDisabled({
          isOn: true,
          isAfter: true,
        });
        break;
      case "ON":
        setDisabled({
          isOn: false,
          isAfter: true,
        });
        break;
      case "AFTER":
        setDisabled({
          isOn: true,
          isAfter: false,
        });
        break;
    }
  }, [endDateType]);

  useEffect(() => {
    dispatch(doGetAllMessageTemplate({ workspaceId: workspaceId }));

    const listBroadcast = SEND_BROADCAST_TYPE.map(br => {
      return {
        id: br,
        name: t(`message.${br}`),
      };
    });
    setOptionBroadcastType(listBroadcast);
    const timeZoneList = moment.tz.names().map(item => {
      return {
        value: item,
        label: item,
      };
    });
    setListTimezone(timeZoneList);
  }, []);

  useEffect(() => {
    if (listMessageTemplate && listMessageTemplate.length > 0) {
      const options = listMessageTemplate.map(item => {
        return {
          id: item.id,
          name: item.title,
        };
      });
      setOptionsMessageTemplate(options);
    }
  }, [listMessageTemplate]);

  const onSubmit = async data => {
    const request = {
      workspaceId: workspaceId,
      timezone: selectedTimezone,
      message: data.message,
    };
    if (broadcastDetail.broadcastType === "DRAFT") {
      request.broadcastType = data.broadcastType;
    }
    if (data.broadcastType === "SEND_LATER") {
      if (!timeLater) {
        setShowErrorMessage(t("validate.required"));
      } else {
        if (!timeLater.toString().includes("/")) {
          request.sendLaterTime = moment
            .utc(timeLater)
            .format("MM/DD/YYYY HH:mm:00");
        } else {
          request.sendLaterTime = timeLater;
        }
        setShowErrorMessage("");
        setLoading(true);
      }
    } else if (data.broadcastType === "REPEAT") {
      if (!timeRepeat) {
        setShowErrorMessage(t("validate.required"));
      } else {
        setLoading(true);
        setShowErrorMessage("");
        const time = moment.utc(timeRepeat).format("HH:mm");
        const custom = {
          type: "CUSTOM",
          time: time,
        };
        if (customListWeek && selectedRepeatType.includes("WEEK")) {
          custom.weekDays = customListWeek;
        }
        custom.customRepeatType = selectedRepeatType.replaceAll("S", "");
        custom.customRepeatAmount = numberRepeat;

        if (customDayMonth && selectedRepeatType.includes("MONTH")) {
          custom.customDayMonth = customDayMonth;
        }
        if (selectedRepeatType.includes("YEAR")) {
          custom.date = moment.utc(customDateYear).format("MM/DD/YYYY");
        }
        const customEndDateField = {
          endDateType: endDateType,
        };
        if (endDateType === "ON") {
          const newDate = customEndDate;
          customEndDateField.endDate = newDate;
        }
        if (endDateType === "AFTER") {
          customEndDateField.amount = amountEndDate;
        }
        custom.customEndDate = customEndDateField;
        request.customBroadcast = custom;
      }
    }
    if (
      data.broadcastType === "DRAFT" ||
      data.broadcastType === "SEND_NOW" ||
      (data.broadcastType !== "DRAFT" && timeRepeat) ||
      (data.broadcastType === "SEND_LATER" && timeLater)
    ) {
      const result = await dispatch(
        doUpdateBroadcast({
          id: broadcastDetail.messageId,
          data: request,
        })
      );
      const { payload } = result;
      setLoading(false);

      if (payload) {
        onCancel();
        dispatch(setIsRefresh(uuid()));
      }
    }
  };

  const handleChange = (key, val) => {
    setFieldValue(key, val);
    if (key === "template" && listMessageTemplate.length > 0) {
      const option = listMessageTemplate.filter(opt => opt.id === val && opt);
      if (option.length > 0) {
        const newMessage = option[0].message;
        setFieldValue("message", newMessage);
      }
    }
  };
  const renderMessageHeader = () => {
    return (
      <div>
        <p>{t("label.message")}</p>
        <FormInput
          items={inputTemplate.map(item => {
            item.label = t(item.label);
            if (item.key) {
              item.value = getIn(values, item.key);
            }
            return { ...item };
          })}
          form={handleForm}
          onChange={handleChange}
          layout={"vertical"}
        />
      </div>
    );
  };
  const validationSchema = Yup.object().shape({
    message: Yup.string()
      .required("validate.required")
      .matches(PATTERNS.XSS_PATTERN, "validate.noxss"),
  });
  const handleForm = useFormik({
    initialValues: {
      senderNumber: "",
      message: "",
      template: "Select Your Template",
    },
    validationSchema: validationSchema,
    onSubmit: onSubmit,
  });
  const { values, setFieldValue, setValues, handleSubmit } = handleForm;

  const inputTemplate = [
    {
      type: "select",
      key: "template",
      placeholder: "Select Your Template",
      options: optionsMessageTemplate,
      style: {
        minWidth: 100,
      },
    },
  ];
  const inputItems = [
    {
      label: "label.senderNumber",
      type: "text",
      key: "address",
      disabled: true,
      config: {
        showCount: true,
        maxLength: 255,
      },
    },
    {
      label: "label.sendType",
      type: "select",
      key: "broadcastType",
      options: optionsBroadcastType,
      config: {
        disabled:
          broadcastDetail && broadcastDetail.broadcastType !== "DRAFT"
            ? true
            : false,
      },
    },
    {
      label: "label.message",
      type: "textarea",
      key: "message",
      placeholder: "label.message",
      value: "",
      labelRender: renderMessageHeader,
      config: {
        showCount: true,
        maxLength: 5000,
      },
    },
  ];

  useEffect(() => {
    if (listMessageTemplate && listMessageTemplate.length > 0) {
      const selectedMessage = listMessageTemplate.find(
        mess => mess.message === broadcastDetail.message
      );
      setValues({
        ...values,
        template: selectedMessage ? selectedMessage.id : null,
      });
    }
  }, [listMessageTemplate]);

  useEffect(() => {
    if (broadcastDetail) {
      setValues({
        ...broadcastDetail,
        sendTime: moment.utc(broadcastDetail.sendTime).local().format("HH:mm"),
      });
      switch (broadcastDetail.broadcastType) {
        case "SEND_LATER":
          setTimeLater(
            moment.tz(broadcastDetail.sendTime, broadcastDetail.timezone)
          );
          break;
        case "REPEAT":
          setNumberRepeat(broadcastDetail.customBroadcast.customRepeatAmount);
          if (broadcastDetail.customBroadcast.customRepeatType === "DAY") {
            if (broadcastDetail.customBroadcast.customRepeatAmount > 1) {
              setSelectedRepeatType("DAYS");
            } else {
              setSelectedRepeatType("DAY");
            }
            const newTime = `${moment().format("MM/DD/YYYY")} ${
              broadcastDetail.customBroadcast.time
            }`;
            setTimeRepeat(moment.tz(newTime, broadcastDetail.timezone));
          } else if (
            broadcastDetail.customBroadcast.customRepeatType === "WEEK"
          ) {
            if (broadcastDetail.customBroadcast.customRepeatAmount > 1) {
              setSelectedRepeatType("WEEKS");
            } else {
              setSelectedRepeatType("WEEK");
            }
            const currentList = broadcastDetail.customBroadcast.weekDays;
            const newList = DAYS_OF_WEEK.map(dy => {
              if (currentList.indexOf(dy.value) !== -1) {
                dy.isChoose = true;
              } else {
                dy.isChoose = false;
              }
              return dy;
            });

            setCustomListWeek(
              newList
                .map(item => {
                  if (item.isChoose) {
                    return item.value;
                  } else {
                    return undefined;
                  }
                })
                .filter(item => item !== undefined)
            );
            setListDays(newList);
            const newTime = `${moment().format("MM/DD/YYYY")} ${
              broadcastDetail.customBroadcast.time
            }`;
            setTimeRepeat(moment.tz(newTime, broadcastDetail.timezone));
          } else if (
            broadcastDetail.customBroadcast.customRepeatType === "MONTH"
          ) {
            if (broadcastDetail.customBroadcast.customRepeatAmount > 1) {
              setSelectedRepeatType("MONTHS");
            } else {
              setSelectedRepeatType("MONTH");
            }
            setCustomDayMonth(
              broadcastDetail.customBroadcast.customDayMonth !== 0
                ? broadcastDetail.customBroadcast.customDayMonth
                : 1
            );
            const newTime = `${moment().format("MM/DD/YYYY")} ${
              broadcastDetail.customBroadcast.time
            }`;
            setTimeRepeat(moment.tz(newTime, broadcastDetail.timezone));
          } else if (
            broadcastDetail.customBroadcast.customRepeatType === "YEAR"
          ) {
            setCustomDateYear(
              moment.tz(
                broadcastDetail.customBroadcast.date,
                broadcastDetail.timezone
              )
            );
            const newTime = `${moment().format("MM/DD/YYYY")} ${
              broadcastDetail.customBroadcast.time
            }`;
            setTimeRepeat(moment.tz(newTime, broadcastDetail.timezone));
            if (broadcastDetail.customBroadcast.customRepeatAmount > 1) {
              setSelectedRepeatType("YEARS");
            } else {
              setSelectedRepeatType("YEAR");
            }
          }
      }
      setSelectedTimezone(broadcastDetail.timezone);
      if (broadcastDetail.customBroadcast) {
        if (broadcastDetail.customBroadcast.customEndDate) {
          setEndDateType(
            broadcastDetail.customBroadcast.customEndDate.endDateType
          );
          if (broadcastDetail.customBroadcast.customEndDate.endDate) {
            setCustomEndDate(
              broadcastDetail.customBroadcast.customEndDate.endDate
            );
          }
          if (broadcastDetail.customBroadcast.customEndDate.amount > 0) {
            setAmountEndDate(
              broadcastDetail.customBroadcast.customEndDate.amount
            );
          }
        }
        setRepeatType(broadcastDetail.customBroadcast.type);
      }
    }
  }, [broadcastDetail]);

  const handleChangeNumber = num => {
    if (num === 1) {
      if (selectedRepeatType.includes("S")) {
        setSelectedRepeatType(selectedRepeatType.replace("S", ""));
      }
    } else {
      if (!selectedRepeatType.includes("S")) {
        setSelectedRepeatType(`${selectedRepeatType}S`);
      }
    }
    setNumberRepeat(num);
  };

  const handleChangeValue = val => {
    setSelectedRepeatType(val);
  };

  useEffect(() => {
    renderDateOfMonth();
  }, []);

  const renderDateOfMonth = () => {
    let arr = [];
    for (let i = 1; i <= 31; i++) {
      arr.push({
        label: i,
        value: i,
      });
    }
    setListDates(arr);
  };

  const handleDaysOfWeekDefault = () => {
    const today = moment.utc().local().day();
    const newList = DAYS_OF_WEEK.map(day => {
      switch (today) {
        case 1:
          if (day.key == "mon") {
            day.isChoose = true;
          }
          break;
        case 2:
          if (day.key == "tue") {
            day.isChoose = true;
          }
          break;
        case 3:
          if (day.key == "wed") {
            day.isChoose = true;
          }
          break;
        case 4:
          if (day.key == "thu") {
            day.isChoose = true;
          }
          break;
        case 5:
          if (day.key == "fri") {
            day.isChoose = true;
          }
          break;
        case 6:
          if (day.key == "sat") {
            day.isChoose = true;
          }
          break;
        case 7:
          if (day.key == "sun") {
            day.isChoose = true;
          }
          break;
      }
      return day;
    });
    setCustomListWeek(
      newList
        .map(item => {
          if (item.isChoose) {
            return item.value;
          } else {
            return undefined;
          }
        })
        .filter(item => item !== undefined)
    );
    setListDays(newList);
  };

  const onChangeStatus = e => {
    const newList = listDays.map(day => {
      if (day.key === e) {
        day.isChoose = !day.isChoose;
      }
      return day;
    });
    const isEmpty = newList.filter(day => day.isChoose).length === 0;
    if (isEmpty) {
      handleDaysOfWeekDefault();
    } else {
      setListDays(newList);
      setCustomListWeek(
        newList
          .map(item => {
            if (item.isChoose) {
              return item.value;
            } else {
              return undefined;
            }
          })
          .filter(item => item !== undefined)
      );
    }
  };

  const onChangeOptionsEnd = e => {
    setEndDateType(e.target.value);
  };

  const onSendMessageLater = datePicker => {
    if (datePicker && datePicker.$d) {
      let newTime = datePicker.$d;
      const minutes = moment(datePicker.$d).minutes();
      const hours = moment(datePicker.$d).hours();

      if (minutes > 0 && minutes <= 5) {
        newTime = moment(datePicker.$d).minutes(5);
      } else if (minutes > 5 && minutes <= 10) {
        newTime = moment(datePicker.$d).minutes(10);
      } else if (minutes > 10 && minutes <= 15) {
        newTime = moment(datePicker.$d).minutes(15);
      } else if (minutes > 15 && minutes <= 20) {
        newTime = moment(datePicker.$d).minutes(20);
      } else if (minutes > 20 && minutes <= 25) {
        newTime = moment(datePicker.$d).minutes(25);
      } else if (minutes > 25 && minutes <= 30) {
        newTime = moment(datePicker.$d).minutes(30);
      } else if (minutes > 30 && minutes <= 35) {
        newTime = moment(datePicker.$d).minutes(35);
      } else if (minutes > 35 && minutes <= 40) {
        newTime = moment(datePicker.$d).minutes(40);
      } else if (minutes > 40 && minutes <= 45) {
        newTime = moment(datePicker.$d).minutes(45);
      } else if (minutes > 45 && minutes <= 50) {
        newTime = moment(datePicker.$d).minutes(50);
      } else if (minutes > 50 && minutes <= 55) {
        newTime = moment(datePicker.$d).minutes(55);
      } else if (minutes > 55 && minutes <= 59) {
        newTime = moment(datePicker.$d)
          .hours(hours + 1)
          .minutes(0);
      }
      setTimeLater(newTime);
      setShowErrorMessage("");
    } else {
      setTimeLater(timeLater);
    }
  };

  const onGetCustomYear = datePicker => {
    if (datePicker) {
      const date = moment(datePicker.$d).format("MM/DD/yyyy");
      setCustomDateYear(date);
      if (date) {
        setShowErrorMessage("");
      }
    } else {
      setCustomDateYear(customDateYear);
    }
  };

  const handleSetTime = time => {
    if (time && time.$d) {
      let newTime = time.$d;
      setTimeRepeat(newTime);
      setShowErrorMessage("");
      if (newTime) {
        setShowErrorMessage("");
      }
    } else {
      setTimeRepeat(timeRepeat);
    }
  };

  const handleSetCustomEndDate = time => {
    if (time) {
      const newTime = moment(time.$d).format("MM/DD/YYYY");
      setCustomEndDate(newTime);
    } else {
      setCustomEndDate(customEndDate);
    }
  };

  const handleGetTimeSendLaterNow = () => {
    const minutues = moment().local().minutes();
    const hours = moment().local().hours();

    if (minutues > 0 && minutues <= 5) {
      setTimeLater(moment().local().minutes(5));
    } else if (minutues > 5 && minutues <= 10) {
      setTimeLater(moment().local().minutes(10));
    } else if (minutues > 10 && minutues <= 15) {
      setTimeLater(moment().local().minutes(15));
    } else if (minutues > 15 && minutues <= 20) {
      setTimeLater(moment().local().minutes(20));
    } else if (minutues > 20 && minutues <= 25) {
      setTimeLater(moment().local().minutes(25));
    } else if (minutues > 25 && minutues <= 30) {
      setTimeLater(moment().local().minutes(30));
    } else if (minutues > 30 && minutues <= 35) {
      setTimeLater(moment().local().minutes(35));
    } else if (minutues > 35 && minutues <= 40) {
      setTimeLater(moment().local().minutes(40));
    } else if (minutues > 40 && minutues <= 45) {
      setTimeLater(moment().local().minutes(45));
    } else if (minutues > 45 && minutues <= 50) {
      setTimeLater(moment().local().minutes(50));
    } else if (minutues > 50 && minutues <= 55) {
      setTimeLater(moment().local().minutes(55));
    } else if (minutues > 55 && minutues <= 59) {
      setTimeLater(
        moment()
          .local()
          .hours(hours + 1)
          .minutes(0)
      );
    }
  };
  const renderExtraFooterSendLater = () => (
    <div
      style={{ display: "flex", alignItems: "center" }}
      onClick={() => handleGetTimeSendLaterNow()}
    >
      <a>{t("label.now")}</a>
    </div>
  );

  const handleGetTimeRepeatNow = () => {
    const minutues = moment().local().minutes();
    const hours = moment().local().hours();

    if (minutues > 0 && minutues <= 5) {
      setTimeRepeat(moment().local().minutes(5));
    } else if (minutues > 5 && minutues <= 10) {
      setTimeRepeat(moment().local().minutes(10));
    } else if (minutues > 10 && minutues <= 15) {
      setTimeRepeat(moment().local().minutes(15));
    } else if (minutues > 15 && minutues <= 20) {
      setTimeRepeat(moment().local().minutes(20));
    } else if (minutues > 20 && minutues <= 25) {
      setTimeRepeat(moment().local().minutes(25));
    } else if (minutues > 25 && minutues <= 30) {
      setTimeRepeat(moment().local().minutes(30));
    } else if (minutues > 30 && minutues <= 35) {
      setTimeRepeat(moment().local().minutes(35));
    } else if (minutues > 35 && minutues <= 40) {
      setTimeRepeat(moment().local().minutes(40));
    } else if (minutues > 40 && minutues <= 45) {
      setTimeRepeat(moment().local().minutes(45));
    } else if (minutues > 45 && minutues <= 50) {
      setTimeRepeat(moment().local().minutes(50));
    } else if (minutues > 50 && minutues <= 55) {
      setTimeRepeat(moment().local().minutes(55));
    } else if (minutues > 55 && minutues <= 59) {
      setTimeRepeat(
        moment()
          .local()
          .hours(hours + 1)
          .minutes(0)
      );
    }
  };

  const renderExtraFooter = () => (
    <div
      style={{ display: "flex", alignItems: "center" }}
      onClick={() => handleGetTimeRepeatNow()}
    >
      <a>{t("label.now")}</a>
    </div>
  );

  const handleFormatDateTimeLocale = () => {
    const browserLocale = navigator.language;
    let dateLocale;
    dateLocale = moment()
      .tz(customer?.timeZone ? customer?.timeZone : moment.tz.guess())
      .locale(browserLocale);
    return `${dateLocale.localeData().longDateFormat("L")} ${dateLocale
      .localeData()
      .longDateFormat("LT")
      .replace("A", "")
      .replace("h", "HH")}`;
  };

  const handleFormatDateLocale = () => {
    const browserLocale = navigator.language;
    let dateLocale;
    dateLocale = moment()
      .tz(customer?.timeZone ? customer?.timeZone : moment.tz.guess())
      .locale(browserLocale);
    return `${dateLocale.format("YYYY-MM-DD")} ${dateLocale.format("LT")}`;
  };

  return (
    <Space
      direction="vertical"
      size="small"
      style={{
        display: "flex",
      }}
    >
      <FormInput
        items={inputItems.map(item => {
          item.label = t(item.label);
          if (item.key) {
            item.value = getIn(values, item.key);
          }
          return { ...item };
        })}
        form={handleForm}
        onChange={setFieldValue}
        layout={"vertical"}
      />
      {values.broadcastType === "SEND_LATER" && (
        <>
          <div style={{ marginBottom: 8 }}>{t("label.DateAndTime")}</div>
          <DatePicker
            placeholder={t("text.selectDateAndTime")}
            format={`${handleFormatDateTimeLocale()}`}
            showTime={{
              format: `HH:mm`,
            }}
            showNow={false}
            onChange={onSendMessageLater}
            needConfirm={false}
            changeOnScroll={true}
            value={timeLater && dayjs(timeLater)}
            disabledDate={currentDate => {
              if (moment(currentDate.$d).year() === moment(new Date()).year()) {
                if (
                  moment(currentDate.$d).month() < moment(new Date()).month()
                ) {
                  return true;
                } else if (
                  moment(currentDate.$d).month() ===
                    moment(new Date()).month() &&
                  moment(currentDate.$d).date() < moment(new Date()).date()
                ) {
                  return true;
                } else {
                  return false;
                }
              } else if (
                moment(currentDate.$d).year() > moment(new Date()).year()
              ) {
                return false;
              } else {
                return false;
              }
            }}
            minuteStep={5}
            style={{
              marginBottom: 8,
              width: "100%",
              borderColor: showErrorMessage ? "red" : "",
            }}
            renderExtraFooter={renderExtraFooterSendLater}
            popupClassName={styles.datePickerPopUp}
          />
          {showErrorMessage && (
            <span style={{ color: "red" }}>{showErrorMessage}</span>
          )}
          <div style={{ marginBottom: 8 }}>{t("label.timezone")}</div>
          <Select
            style={{ marginBottom: 8, width: "100%" }}
            defaultValue={selectedTimezone}
            options={listTimezone}
            onChange={setSelectedTimezone}
            showSearch={true}
          />
        </>
      )}
      {values.broadcastType === "REPEAT" && (
        <>
          <Space
            align="start"
            style={{
              width: "100%",
              marginTop: "10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div>{t("label.repeatEvery")}</div>
            <div>
              <InputNumber
                min={1}
                defaultValue={1}
                max={selectedRepeatType}
                value={numberRepeat}
                onChange={handleChangeNumber}
                style={{ marginRight: 8 }}
              />
              <Select
                style={{ width: 100 }}
                options={
                  numberRepeat === 1
                    ? OPTIONS_REPEAT.filter(
                        option => !option.value.includes("S") && option
                      )
                    : OPTIONS_REPEAT.filter(
                        option => option.value.includes("S") && option
                      )
                }
                placeholder={"Select"}
                value={selectedRepeatType}
                onChange={handleChangeValue}
              />
            </div>
          </Space>
          {selectedRepeatType.includes("WEEK") && (
            <Space
              direction={"vertical"}
              align="start"
              style={{ width: "100%", marginTop: "10px" }}
            >
              <div>{t("label.repeatOn")}</div>
              <div style={{ display: "inline" }}>
                {listDays.map(day => {
                  return (
                    <Tooltip key={`${day.key}`} title={day.title}>
                      <Button
                        key={day.key}
                        value={day.key}
                        type={day.isChoose ? "primary" : "default"}
                        shape="circle"
                        style={{ marginLeft: day.key !== "sun" ? "10px" : "" }}
                        onClick={() => onChangeStatus(day.key)}
                      >
                        {day.label}
                      </Button>
                    </Tooltip>
                  );
                })}
              </div>
            </Space>
          )}
          {selectedRepeatType.includes("MONTH") && (
            <Space
              direction={"vertical"}
              align="start"
              style={{
                width: "100%",
                marginTop: "10px",
              }}
            >
              <div>{t("text.selectDayofMonth")}</div>
              <Select
                style={{ marginBottom: 8, width: "70px" }}
                options={listDates}
                defaultValue={customDayMonth ? customDayMonth : 1}
                onChange={setCustomDayMonth}
              />
            </Space>
          )}
          {selectedRepeatType.includes("YEAR") && (
            <Space
              direction={"vertical"}
              align="start"
              style={{
                width: "100%",
                marginTop: "10px",
              }}
            >
              <div>{t("text.selectDateRepeat")}</div>
              <DatePicker
                format={`${handleFormatDateLocale()}`}
                onChange={onGetCustomYear}
                showNow={true}
                needConfirm={false}
                changeOnScroll={true}
                value={customDateYear && dayjs(customDateYear)}
                disabledDate={currentDate => {
                  if (
                    moment(currentDate.$d).year() === moment(new Date()).year()
                  ) {
                    if (
                      moment(currentDate.$d).month() <
                      moment(new Date()).month()
                    ) {
                      return true;
                    } else if (
                      moment(currentDate.$d).month() ===
                        moment(new Date()).month() &&
                      moment(currentDate.$d).date() < moment(new Date()).date()
                    ) {
                      return true;
                    } else {
                      return false;
                    }
                  } else if (
                    moment(currentDate.$d).year() > moment(new Date()).year()
                  ) {
                    return false;
                  } else {
                    return false;
                  }
                }}
              />
            </Space>
          )}
          <Space
            direction={"vertical"}
            align="start"
            style={{ width: "100%", marginTop: "10px" }}
          >
            <div>
              <div style={{ marginBottom: 8 }}>{t("label.timezone")}</div>
              <Select
                style={{ marginBottom: 8, width: "100%" }}
                defaultValue={selectedTimezone}
                options={listTimezone}
                onChange={setSelectedTimezone}
              />
            </div>
            <div style={{ display: "inline", width: "100%" }}>
              <div>{t("label.timeRepeat")}</div>
              <div style={{ width: "100%", marginTop: 8 }}>
                <TimePicker
                  format={"HH:mm"}
                  minuteStep={5}
                  value={timeRepeat ? dayjs(moment(timeRepeat)) : null}
                  style={{
                    width: "100%",
                    borderColor: showErrorMessage !== "" ? "red" : "",
                  }}
                  showNow={false}
                  onChange={handleSetTime}
                  renderExtraFooter={renderExtraFooter}
                  popupClassName={styles.timePickerPopUp}
                  onSelect={handleSetTime}
                  needConfirm={false}
                  changeOnScroll={true}
                />
                {showErrorMessage && (
                  <span style={{ color: "red" }}>{showErrorMessage}</span>
                )}
              </div>
            </div>
          </Space>
          <Space
            direction={"vertical"}
            align="start"
            style={{ width: "100%", marginTop: "10px", marginBottom: "30px" }}
          >
            <div style={{ width: "100%" }}>{t("label.ends")}</div>
            <Row style={{ width: "100%", minWidth: 450 }}>
              <Col span={12} style={{ width: "100%" }}>
                <Radio.Group
                  onChange={onChangeOptionsEnd}
                  defaultValue={endDateType ? endDateType : "NONE"}
                >
                  <Space direction="vertical" style={{ width: "100%" }}>
                    <Radio value={"NONE"}>{t("label.never")}</Radio>
                    <Radio value={"ON"} style={{ marginTop: "20px" }}>
                      {t("label.on")}
                    </Radio>
                    <Radio value={"AFTER"} style={{ marginTop: "20px" }}>
                      {t("label.after")}
                    </Radio>
                  </Space>
                </Radio.Group>
              </Col>
              <Col span={12} style={{ width: "100%" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-end",
                    width: "100%",
                    height: "100%",
                  }}
                >
                  <DatePicker
                    style={{ width: "100%", marginBottom: "10px" }}
                    disabled={disabled.isOn}
                    format={`${handleFormatDateLocale()}`}
                    showNow={true}
                    value={
                      customEndDate &&
                      dayjs(moment.tz(customEndDate, broadcastDetail.timezone))
                    }
                    onChange={handleSetCustomEndDate}
                    disabledDate={currentDate => {
                      if (
                        moment(currentDate.$d).year() ===
                        moment(new Date()).year()
                      ) {
                        if (
                          moment(currentDate.$d).month() <
                          moment(new Date()).month()
                        ) {
                          return true;
                        } else if (
                          moment(currentDate.$d).month() ===
                            moment(new Date()).month() &&
                          moment(currentDate.$d).date() <
                            moment(new Date()).date()
                        ) {
                          return true;
                        } else {
                          return false;
                        }
                      } else if (
                        moment(currentDate.$d).year() >
                        moment(new Date()).year()
                      ) {
                        return false;
                      } else {
                        return false;
                      }
                    }}
                  />
                  <InputNumber
                    addonAfter={"occurrences"}
                    min={1}
                    disabled={disabled.isAfter}
                    onChange={setAmountEndDate}
                    value={amountEndDate}
                  />
                </div>
              </Col>
            </Row>
          </Space>
        </>
      )}
      <Space
        style={{
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <AppButton
          label={t("label.cancel")}
          color={"grey"}
          loading={loading}
          type="button"
          onClick={() => {
            onCancel();
          }}
          size={"medium"}
          className={"cancelButton"}
        />
        <AppButton
          label={t("button.save")}
          color={"blue"}
          loading={loading}
          type="submit"
          onClick={handleSubmit}
          size={"medium"}
        />
      </Space>
    </Space>
  );
};

export default MessageUpdateForm;
